import React from 'react';
import api from '../../utils/api';
import { connect } from 'react-redux';

class LogoutView extends React.Component {
    componentDidMount = () => this.props.dispatch(api.actions.auth.logoutUser());
    render = () => null;
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogoutView);
